import React, { useState } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { CreateCSSProperties } from "@material-ui/core/styles/withStyles";
import { useDropzone } from "react-dropzone";
import Warning from './WarningComponent';
import {  Box, CircularProgress} from "@material-ui/core";



const Configuration     = require("shared/services/Configuration");
const Storage           = require("shared/services/Storage");

const useStyles = makeStyles<CreateCSSProperties>(() => ({
  uploadBtn: {
    textTransform: 'none',
    color: '#475569',
    fontSize: '1.2rem',
    fontWeight: 500,
    backgroundColor: '#FFFFFF',
    padding: 0,
  }
}));

export const uploadImages = async (binaryData: Buffer, imageName: string, folderPath: string): Promise<any | boolean> => {
  const token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
  try {
    const res = await fetch(
      `${Configuration.c3ApibaseUrl}/v1/images?filename=${imageName}&folderPath=${folderPath}`,
      {
        body: binaryData,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/octet-stream",
        },
        method: "POST",
      }
    );

    if (res.status !== 200 && res.status !== 409) return false;
    return await res.json();
  } catch (e) {
    return false;
  }
}

const renderLoader = () => (
  /* @ts-ignore */
  <Box
      style={{ display: "flex", justifyContent: "center", marginBottom: "2px",marginTop:"2px" }}
  >
      <CircularProgress size={15} color="inherit" />
  </Box>
);

const getFolderDetails = async (folderId: string): Promise<any | boolean> => {
  const token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
  try {
    const res = await fetch(`${Configuration.c3ApibaseUrl}/v1/imageFolders/${folderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "GET",
    });
    console.log(res, 'Response');
    if (res.status !== 200) return false;
    return await res.json();
  } catch (e) {
    console.error(e);
    return false;
  }
}

const isValidImageOrFolderName = (name: string) => {
  const format = /[#%&{}/|:?<>*"@'!$+`=]+/;
  // OR condition has a special case for backslash which is an escape sequence
  if (format.test(name) || name.includes("\\") || name.trim().length === 0) {
    return false;
  } else {
    return true;
  }
};

const UploadImageButton = (props) => {
  const { setImageList, folderPath } = props;
  const [warningData, setWarningData] = useState({
    show: false,
    heading: 'Warning',
    subHeading: 'Duplicate Images',
    primaryButtonClick: () => { setWarningData(prev => ({ ...prev, show: false })) },
  });
  const [loader,setLoader]=useState<boolean>(false);

  const classes = useStyles();

  const getFolderName = async (folderPath: string) => {
    const folderName = ["Images"];
    if (folderPath === "/") return folderName;
    const folderIdArr = folderPath.split("/").filter((el) => el !== "");
    const res = await Promise.all(
      folderIdArr.map(async (el) => await getFolderDetails(el))
    );
    folderName.push(...res.map((el) => el.folderDetails.name));
    return folderName;
  };

  const onDrop = (files: any[]) => {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      console.log(file, 'FIle');
      reader.onload = async () => {
        // Check name for invalid characters
        if (!isValidImageOrFolderName(file.name)) {
          setWarningData(prev => ({
            ...prev,
            show: true,
            subHeading:
              "Unable to upload " +
              file.name +
              ". The file name contains a character (#%&{}/|&#92;:?<>*\"@'!$+`= or cannot be blank) which are not supported."
          }));
          return;
        }
        const binaryData = Buffer.from(reader.result as string, "binary");
        setLoader(true);
        const res = await uploadImages(
          binaryData,
          file.name,
          folderPath,
        );
        if (res.imageDetails) {
          // on successful upload
          setImageList((prev) => [res.imageDetails, ...prev]);
        } else if (res.imageId) {
          // if image is already present in library
          const folderName = await getFolderName(res.folderPath);
          setWarningData(prev => ({ ...prev, show: true, subHeading: `The file already exists in ${folderName.join("/")}` }))
        }
        setLoader(false);
      };
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    // Our API supports all image formats, Legacy Editor only supports jpg, jpeg, png, gif
    // accept: ["image/jpeg", "image/png", "image/gif"],
    minSize: 0,
    maxSize: 5242880, // Setting the Max upload size to 5MB due to AWS Lambda limitations
    onDropRejected: (err) => {
      const errorCode = err[0].errors[0].code;
      if (errorCode === "file-too-large") {
        setWarningData(prev => ({ ...prev, show: true, subHeading: "This file exceeds the maximum size limit of 5 MB." }));
      }
    },
  });

  return (
    <>
      <Warning
        data={warningData}
      />
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <Button className={classes.uploadBtn} variant="outlined">{loader ? renderLoader() : "Upload"}</Button>
      </div >
    </>
  )
}

export default UploadImageButton;


// WEBPACK FOOTER //
// ./src/editor/ui/editor/imageLibrary/UploadImage.tsx